import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { UserRole } from './shared/models/user.model';

export const routes: Routes = [
    {
        path: 'login',
        loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent),
    },
    {
        path: 'callback',
        loadComponent: () => import('./auth/callback/callback.component').then(m => m.CallbackComponent),
    },
    {
        path: 'forbidden',
        loadComponent: () => import('./shared/pages/forbidden/forbidden.component').then(m => m.ForbiddenComponent),
    },
    {
        path: 'certificate/:certificate_id',
        loadComponent: () => import('./shared/component/certificate-public-view/certificate-public-view.component').then(m => m.CertificatePublicViewComponent)
    },
    {
        path: 'video-poc',
        loadComponent: () => import('./features/video-poc/video-poc.component').then(m => m.VideoPocComponent)
    },
    {
        path: 'home',
        loadChildren: () => import('./features/learner/learner.routes').then(m => m.learnerRoutes),
        canActivate: [AuthGuard],
        data: { roles: [UserRole.Learner] }
    },
    {
        path: 'learner',
        loadChildren: () => import('./features/learner/learner.routes').then(m => m.learnerRoutes),
        canActivate: [AuthGuard],
        data: { roles: [UserRole.Learner] }
    },
    {
        path: 'trainer',
        loadChildren: () => import('./features/trainer/trainer.routes').then(m => m.trainerRoutes),
        canActivate: [AuthGuard],
        data: { roles: [UserRole.Trainer] }
    },
    {
        path: 'admin',
        loadChildren: () => import('./features/admin/admin.routes').then(m => m.adminRoutes),
        canActivate: [AuthGuard],
        data: { roles: [UserRole.Admin] }
    },
    {
        path:'',
        redirectTo: 'login',
        pathMatch: 'full'
    }
];
